import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const LogoAppStoreLinksIcon = (props: IconProps) => (
  <Icon w="130px" h="135" viewBox="0 0 130 135" {...props}>
    <path
      fill="url(#a)"
      d="M90.929 27.267H37.652c-7.355 0-13.319 5.912-13.319 13.204 0 7.29 5.964 13.203 13.32 13.203h53.276c7.355 0 13.319 5.912 13.319 13.203V40.471c0-7.291-5.964-13.204-13.32-13.204Z"
    />
    <path
      fill="url(#b)"
      d="M90.928 53.674H64.29c-7.355 0-13.319 5.912-13.319 13.203v26.407c0-7.291 5.964-13.203 13.32-13.203h26.637c7.355 0 13.319-5.913 13.319-13.204 0-7.29-5.964-13.203-13.319-13.203Z"
    />
    <path
      fill="url(#c)"
      d="M37.652.86c-7.355 0-13.319 5.913-13.319 13.204v26.407c0-7.291 5.964-13.204 13.32-13.204H64.29c7.356 0 13.32-5.912 13.32-13.203V.861H37.652Z"
    />
    <path
      fill="#282644"
      d="M7.58 115.002c3.803.827 5.558 2.213 5.558 4.842 0 2.944-2.436 4.843-5.828 4.843-2.705 0-4.924-.901-6.977-2.726l1.196-1.41c1.779 1.604 3.488 2.408 5.85 2.408 2.364 0 3.804-1.192 3.804-2.921 0-1.603-.852-2.504-4.438-3.257-3.928-.85-5.73-2.116-5.73-4.94 0-2.823 2.367-4.671 5.61-4.671 2.488 0 4.267.707 6 2.093l-1.122 1.483c-1.584-1.289-3.169-1.848-4.925-1.848-2.219 0-3.632 1.215-3.632 2.772 0 1.558.88 2.533 4.633 3.332ZM32.068 124.442h-1.95v-6.737l-7.098-10.29h2.34l5.754 8.516 5.805-8.516h2.242l-7.098 10.267v6.76h.005ZM63.242 107.415h1.877v17.027H63.58l-11.022-13.964v13.964h-1.876v-17.027h1.806l10.753 13.645v-13.645ZM86.193 124.733c-4.924 0-8.561-3.867-8.561-8.779s3.609-8.83 8.63-8.83c3.1 0 4.953 1.095 6.658 2.698l-1.316 1.409c-1.44-1.363-3.048-2.333-5.364-2.333-3.78 0-6.611 3.04-6.611 7.005 0 3.964 2.853 7.056 6.61 7.056 2.34 0 3.878-.901 5.514-2.459l1.27 1.243c-1.78 1.802-3.73 2.995-6.83 2.995v-.005ZM112.267 124.733c-5.193 0-8.682-4.062-8.682-8.779 0-4.718 3.535-8.83 8.733-8.83s8.682 4.061 8.682 8.779-3.535 8.83-8.733 8.83Zm0-15.835c-3.901 0-6.68 3.114-6.68 7.005s2.83 7.056 6.731 7.056 6.681-3.115 6.681-7.005c0-3.891-2.831-7.056-6.732-7.056Z"
    />
    <path
      fill="#ADADAD"
      d="M121.902 107.205v-.502h3.002v.502h-1.211v3.367h-.583v-3.367h-1.208ZM125.46 106.703h.71l1.235 3.007h.046l1.235-3.007h.71v3.869h-.557v-2.8h-.036l-1.144 2.794h-.462l-1.144-2.796h-.036v2.802h-.557v-3.869Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1="24.333"
        x2="104.248"
        y1="47.072"
        y2="47.072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset=".36" stopColor="#F68F1D" />
        <stop offset=".79" stopColor="#FCBD08" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="50.971"
        x2="104.247"
        y1="73.479"
        y2="73.479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset=".34" stopColor="#EE6130" />
        <stop offset=".56" stopColor="#E85830" />
        <stop offset=".75" stopColor="#DC492F" />
        <stop offset=".91" stopColor="#CC352D" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="24.333"
        x2="77.61"
        y1="20.666"
        y2="20.666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9500" />
        <stop offset=".09" stopColor="#FFA900" />
        <stop offset=".19" stopColor="#FFBA00" />
        <stop offset=".32" stopColor="#FFC600" />
        <stop offset=".5" stopColor="#FFCD00" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(LogoAppStoreLinksIcon);
